
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.385","height":"18.385","viewBox":"0 0 18.385 18.385"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"prefix__Group_786","data-name":"Group 786","transform":"translate(-550.727 -316.207)"}},[_c('path',{staticClass:"prefix__cls-1",attrs:{"id":"prefix__Line_6","d":"M0 0v24","data-name":"Line 6","transform":"rotate(45 -98.347 844.583)"}}),_c('path',{staticClass:"prefix__cls-1",attrs:{"id":"prefix__Line_7","d":"M0 0v24","data-name":"Line 7","transform":"rotate(135 215.053 284.663)"}})])])
          )
        }
      }
    